import React from 'react';
import { Box, Link, Typography } from "@mui/material";
import { withTranslation } from "react-i18next";
import 'bootstrap-icons/font/bootstrap-icons.css';


const WarningBox = ({ t, title, content }) => {
    return (
        <div
            className="col-xs-11 col-md-12 col-lg-8 bookmark-alert"
        >
            <i className="bi bi-bookmark-plus-fill" style={{ margin: 'auto 16px', fontSize: "1.2rem", color: "#0058a4" }}></i>
            <Box pb={1} >
                <h2 style={{ margin: '12px 0px 16px 0px' }}>
                    {title}
                </h2>
                {content}
            </Box>
        </div>
    )
}

export default withTranslation("common")(WarningBox)